export const URL_TYPES = {
  CORE_DOMAIN: "core-domain",
  FQDN: "fqdn",
  PUBLIC_SUFFIX: "public-suffix",
};
